import { bfsUserWebHttp, otmsHttp } from '@/utils/http/index'

/**
 * 分页查询绑定下级的货主列表
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/18001
 */
export function getSubordinate(data, params) {
  return otmsHttp.post({
    url: '/customer/bind_children_page',
    method: 'post',
    data,
    params
  })
}

/**
 * 账号列表
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9332
 */
export function getAccount(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/page',
    method: 'post',
    data,
    params
  })
}

/**
 * 删除账号
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9336
 */
export function deleteAccount(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/delete',
    method: 'post',
    data,
    params,
    noEnterprise:true
  })
}

/**
 * 重置账号密码
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9338
 */
export function resetAccount(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/password/reset',
    method: 'post',
    data,
    params
  })
}

/**
 * 管理员获取权限树
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9262
 */
export function getAdminFunctionTree(data, params) {
  return otmsHttp.post({
    url: '/permission-plus/admin/system/permission/tree',
    method: 'post',
    data,
    params
  })
}

/**
 * 根据账号获取权限树
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/9236
 */
export function getUserFunctionTree(data, params) {
  return otmsHttp.post({
    url: '/permission-plus/account/permission/tree',
    method: 'post',
    data,
    params
  })
}

/**
 * 组织树
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9272
 */
export function getAccountTree(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/organization/tree',
    method: 'post',
    data,
    params
  })
}

/**
 * 账号和身份关系
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9274
 */
export function getAccountIdentity(data, params) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_identity/list',
    method: 'post',
    data,
    params
  })
}

/**
 * 账号和组织
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/18011
 */
export function getAccountOrg(data, params) {
  return otmsHttp.post({
    url: '/customer/account_org/list',
    method: 'post',
    data,
    params
  })
}

/**
 * 新增货主账号
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9342
 */
export function addAccounts(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/save_or_edit',
    method: 'post',
    data,
  })
}

/**
 * 修改账号基本信息
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9382
 */
export function editAccount(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/edit_base_account_info',
    method: 'post',
    data,
  })
}

/**
 * 查询货主账号是否存在
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/9330
 */
export function verificationAccount(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/customer_account/list',
    method: 'post',
    data,
  })
}

// 根据账号查询组织列表 TREE
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function organizationTree(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_org/organization/tree',
    method: 'post',
    data,
  })
}
export function organizationTreeProject(data,params) {
  return bfsUserWebHttp.post({
    url:'/crm-plus/project/page',
    method: 'post',
    data,
    params,
  })
}

// 根据账号查询组织列表 TREE
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function organizationCorpTree(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_org/organization/corp_customer_tree',
    method: 'post',
    data,
  })
}
// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function organizationList(data) {
  return bfsUserWebHttp.post({
    // url: '/bfs-user/account_org/organization/list',
    url:'/crm-plus/project/list',
    method: 'post',
    data,
  })
}

// 保存货主消息推送配置
// https://yapi.ops.yunlizhi.cn/project/194/interface/api/16681
export function messagePush(data) {
  return otmsHttp.post({
    url: '/order/config/push/config/upsert',
    method: 'post',
    data,
  })
}

// 获取货主消息推送配置
// https://yapi.ops.yunlizhi.cn/project/194/interface/api/16785
export function getMessage(data) {
  return otmsHttp.post({
    url: '/order/config/push/config/query',
    method: 'post',
    data,
  })
}

// 根据账号查询组织列表
// https://yapi.ops.yunlizhi.cn/project/10/interface/api/9448
export function getOrganizationList(data) {
  return bfsUserWebHttp.post({
    url: '/bfs-user/account_org/organization/corp_customer_list',
    method: 'post',
    data,
  })
}

// 项目&货主账号关系更新
// https://yapi.ops.yunlizhi.cn/project/295/interface/api/30308
export function projectAccountRelationUpsert(data) {
  return bfsUserWebHttp.post({
    url: '/crm-plus/project/account_relation/upsert',
    method: 'post',
    data,
  })
}
